import { TBucketId } from '../../bucket-storage.types';
import { TCameraModel } from './camera.types';

export const CAMERA_MODEL = {
  identity: (id: TBucketId = 'BUCKET_ID_temp'): TCameraModel => {
    return {
      state: 'INTIALIZE',
      bucketInfo: {
        name: 'defectives',
        id,
        limit: 3,
        files: [],
        activeFileIndex: -1,
      },
    };
  },
  updateState: (state: TCameraModel['state'], cameraModel: TCameraModel): TCameraModel => {
    return {
      ...cameraModel,
      state,
    };
  },
  updateBucketFiles: (files: TCameraModel['bucketInfo']['files'], cameraModel: TCameraModel): TCameraModel => {
    return {
      ...cameraModel,
      bucketInfo: {
        ...cameraModel.bucketInfo,
        files,
        hasLimitReached: files.length === cameraModel.bucketInfo.limit,
        activeFileIndex: files.length > 0 ? files.length - 1 : -1,
      },
    };
  },
  updatePreviewIndex: (fileIndex: number, cameraModel: TCameraModel): TCameraModel => {
    return {
      ...cameraModel,
      bucketInfo: {
        ...cameraModel.bucketInfo,
        activeFileIndex: fileIndex,
      },
    };
  },
};
